import { render, staticRenderFns } from "./PostData.vue?vue&type=template&id=c20b0056&scoped=true&"
import script from "./PostData.vue?vue&type=script&lang=js&"
export * from "./PostData.vue?vue&type=script&lang=js&"
import style0 from "./PostData.vue?vue&type=style&index=0&id=c20b0056&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20b0056",
  null
  
)

export default component.exports